"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomScoringSource = exports.ExpectedReturnCode = exports.ExpectedOutputSource = exports.StdinSource = exports.ValueFeedbackLevel = exports.NewAGTestCommandData = exports.AGTestCommand = exports.AGTestCommandData = void 0;
var http_client_1 = require("./http_client");
var utils_1 = require("./utils");
var AGTestCommandData = /** @class */ (function () {
    function AGTestCommandData(args) {
        this.pk = args.pk;
        this.name = args.name;
        this.ag_test_case = args.ag_test_case;
        this.last_modified = args.last_modified;
        this.cmd = args.cmd;
        this.internal_admin_notes = args.internal_admin_notes;
        this.staff_description = args.staff_description;
        this.student_description = args.student_description;
        this.student_on_fail_description = args.student_on_fail_description;
        this.stdin_source = args.stdin_source;
        this.stdin_text = args.stdin_text;
        this.stdin_instructor_file = args.stdin_instructor_file;
        this.expected_return_code = args.expected_return_code;
        this.expected_stdout_source = args.expected_stdout_source;
        this.expected_stdout_text = args.expected_stdout_text;
        this.expected_stdout_instructor_file = args.expected_stdout_instructor_file;
        this.expected_stderr_source = args.expected_stderr_source;
        this.expected_stderr_text = args.expected_stderr_text;
        this.expected_stderr_instructor_file = args.expected_stderr_instructor_file;
        this.custom_scoring_source = args.custom_scoring_source;
        this.custom_scoring_regex = args.custom_scoring_regex;
        this.max_points_for_custom_scoring = args.max_points_for_custom_scoring;
        this.custom_scoring_label = args.custom_scoring_label;
        this.ignore_case = args.ignore_case;
        this.ignore_whitespace = args.ignore_whitespace;
        this.ignore_whitespace_changes = args.ignore_whitespace_changes;
        this.ignore_blank_lines = args.ignore_blank_lines;
        this.points_for_correct_return_code = args.points_for_correct_return_code;
        this.points_for_correct_stdout = args.points_for_correct_stdout;
        this.points_for_correct_stderr = args.points_for_correct_stderr;
        this.deduction_for_wrong_return_code = args.deduction_for_wrong_return_code;
        this.deduction_for_wrong_stdout = args.deduction_for_wrong_stdout;
        this.deduction_for_wrong_stderr = args.deduction_for_wrong_stderr;
        this.normal_fdbk_config = args.normal_fdbk_config;
        this.first_failed_test_normal_fdbk_config = args.first_failed_test_normal_fdbk_config;
        this.ultimate_submission_fdbk_config = args.ultimate_submission_fdbk_config;
        this.past_limit_submission_fdbk_config = args.past_limit_submission_fdbk_config;
        this.staff_viewer_fdbk_config = args.staff_viewer_fdbk_config;
        this.time_limit = args.time_limit;
        this.use_virtual_memory_limit = args.use_virtual_memory_limit;
        this.virtual_memory_limit = args.virtual_memory_limit;
        this.block_process_spawn = args.block_process_spawn;
    }
    return AGTestCommandData;
}());
exports.AGTestCommandData = AGTestCommandData;
var AGTestCommand = /** @class */ (function (_super) {
    __extends(AGTestCommand, _super);
    function AGTestCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AGTestCommand.subscribe = function (observer) {
        AGTestCommand._subscribers.add(observer);
    };
    AGTestCommand.unsubscribe = function (observer) {
        AGTestCommand._subscribers.delete(observer);
    };
    AGTestCommand.get_all_from_ag_test_case = function (ag_test_case_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/ag_test_cases/" + ag_test_case_pk + "/ag_test_commands/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.map(function (data) { return new AGTestCommand(data); })];
                }
            });
        });
    };
    AGTestCommand.get_by_pk = function (ag_test_command_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/ag_test_commands/" + ag_test_command_pk + "/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new AGTestCommand(response.data)];
                }
            });
        });
    };
    AGTestCommand.create = function (ag_test_case_pk, data) {
        return __awaiter(this, void 0, void 0, function () {
            var response, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().post("/ag_test_cases/" + ag_test_case_pk + "/ag_test_commands/", data)];
                    case 1:
                        response = _a.sent();
                        result = new AGTestCommand(response.data);
                        AGTestCommand.notify_ag_test_command_created(result);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    AGTestCommand.notify_ag_test_command_created = function (ag_test_command) {
        var e_1, _a;
        try {
            for (var _b = __values(AGTestCommand._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_ag_test_command_created(ag_test_command);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    AGTestCommand.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().patch("/ag_test_commands/" + this.pk + "/", utils_1.filter_keys(this, AGTestCommand.EDITABLE_FIELDS))];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, new AGTestCommand(response.data));
                        AGTestCommand.notify_ag_test_command_changed(this);
                        return [2 /*return*/];
                }
            });
        });
    };
    AGTestCommand.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var last_modified, reloaded;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        last_modified = this.last_modified;
                        return [4 /*yield*/, AGTestCommand.get_by_pk(this.pk)];
                    case 1:
                        reloaded = _a.sent();
                        utils_1.safe_assign(this, reloaded);
                        if (last_modified !== this.last_modified) {
                            AGTestCommand.notify_ag_test_command_changed(this);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AGTestCommand.notify_ag_test_command_changed = function (ag_test_command) {
        var e_2, _a;
        try {
            for (var _b = __values(AGTestCommand._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_ag_test_command_changed(ag_test_command);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    AGTestCommand.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().delete("/ag_test_commands/" + this.pk + "/")];
                    case 1:
                        _a.sent();
                        AGTestCommand.notify_ag_test_command_deleted(this);
                        return [2 /*return*/];
                }
            });
        });
    };
    AGTestCommand.notify_ag_test_command_deleted = function (ag_test_command) {
        var e_3, _a;
        try {
            for (var _b = __values(AGTestCommand._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_ag_test_command_deleted(ag_test_command);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    AGTestCommand.get_order = function (ag_test_case_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/ag_test_cases/" + ag_test_case_pk + "/ag_test_commands/order/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    AGTestCommand.update_order = function (ag_test_case_pk, ag_test_command_order) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().put("/ag_test_cases/" + ag_test_case_pk + "/ag_test_commands/order/", ag_test_command_order)];
                    case 1:
                        response = _a.sent();
                        AGTestCommand.notify_ag_test_command_order_updated(ag_test_case_pk, response.data);
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    AGTestCommand.notify_ag_test_command_order_updated = function (ag_test_case_pk, ag_test_command_order) {
        var e_4, _a;
        try {
            for (var _b = __values(AGTestCommand._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_ag_test_commands_order_changed(ag_test_case_pk, ag_test_command_order);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    AGTestCommand._subscribers = new Set();
    AGTestCommand.EDITABLE_FIELDS = [
        'name',
        'cmd',
        'internal_admin_notes',
        'staff_description',
        'student_description',
        'student_on_fail_description',
        'stdin_source',
        'stdin_text',
        'stdin_instructor_file',
        'expected_return_code',
        'expected_stdout_source',
        'expected_stdout_text',
        'expected_stdout_instructor_file',
        'expected_stderr_source',
        'expected_stderr_text',
        'expected_stderr_instructor_file',
        'custom_scoring_source',
        'custom_scoring_regex',
        'max_points_for_custom_scoring',
        'custom_scoring_label',
        'ignore_case',
        'ignore_whitespace',
        'ignore_whitespace_changes',
        'ignore_blank_lines',
        'points_for_correct_return_code',
        'points_for_correct_stdout',
        'points_for_correct_stderr',
        'deduction_for_wrong_return_code',
        'deduction_for_wrong_stdout',
        'deduction_for_wrong_stderr',
        'normal_fdbk_config',
        'first_failed_test_normal_fdbk_config',
        'ultimate_submission_fdbk_config',
        'past_limit_submission_fdbk_config',
        'staff_viewer_fdbk_config',
        'time_limit',
        'use_virtual_memory_limit',
        'virtual_memory_limit',
        'block_process_spawn',
    ];
    return AGTestCommand;
}(AGTestCommandData));
exports.AGTestCommand = AGTestCommand;
var NewAGTestCommandData = /** @class */ (function () {
    function NewAGTestCommandData(args) {
        this.name = args.name;
        this.cmd = args.cmd;
        this.internal_admin_notes = args.internal_admin_notes;
        this.staff_description = args.staff_description;
        this.student_description = args.student_description;
        this.student_on_fail_description = args.student_on_fail_description;
        this.stdin_source = args.stdin_source;
        this.stdin_text = args.stdin_text;
        this.stdin_instructor_file = args.stdin_instructor_file;
        this.expected_return_code = args.expected_return_code;
        this.expected_stdout_source = args.expected_stdout_source;
        this.expected_stdout_text = args.expected_stdout_text;
        this.expected_stdout_instructor_file = args.expected_stdout_instructor_file;
        this.expected_stderr_source = args.expected_stderr_source;
        this.expected_stderr_text = args.expected_stderr_text;
        this.expected_stderr_instructor_file = args.expected_stderr_instructor_file;
        this.custom_scoring_source = args.custom_scoring_source;
        this.custom_scoring_regex = args.custom_scoring_regex;
        this.max_points_for_custom_scoring = args.max_points_for_custom_scoring;
        this.ignore_case = args.ignore_case;
        this.ignore_whitespace = args.ignore_whitespace;
        this.ignore_whitespace_changes = args.ignore_whitespace_changes;
        this.ignore_blank_lines = args.ignore_blank_lines;
        this.points_for_correct_return_code = args.points_for_correct_return_code;
        this.points_for_correct_stdout = args.points_for_correct_stdout;
        this.points_for_correct_stderr = args.points_for_correct_stderr;
        this.deduction_for_wrong_return_code = args.deduction_for_wrong_return_code;
        this.deduction_for_wrong_stdout = args.deduction_for_wrong_stdout;
        this.deduction_for_wrong_stderr = args.deduction_for_wrong_stderr;
        this.normal_fdbk_config = args.normal_fdbk_config;
        this.first_failed_test_normal_fdbk_config = args.first_failed_test_normal_fdbk_config;
        this.ultimate_submission_fdbk_config = args.ultimate_submission_fdbk_config;
        this.past_limit_submission_fdbk_config = args.past_limit_submission_fdbk_config;
        this.staff_viewer_fdbk_config = args.staff_viewer_fdbk_config;
        this.time_limit = args.time_limit;
        this.use_virtual_memory_limit = args.use_virtual_memory_limit;
        this.virtual_memory_limit = args.virtual_memory_limit;
        this.block_process_spawn = args.block_process_spawn;
    }
    return NewAGTestCommandData;
}());
exports.NewAGTestCommandData = NewAGTestCommandData;
var ValueFeedbackLevel;
(function (ValueFeedbackLevel) {
    ValueFeedbackLevel["no_feedback"] = "no_feedback";
    ValueFeedbackLevel["correct_or_incorrect"] = "correct_or_incorrect";
    ValueFeedbackLevel["expected_and_actual"] = "expected_and_actual";
})(ValueFeedbackLevel = exports.ValueFeedbackLevel || (exports.ValueFeedbackLevel = {}));
var StdinSource;
(function (StdinSource) {
    StdinSource["none"] = "none";
    StdinSource["text"] = "text";
    StdinSource["instructor_file"] = "instructor_file";
    StdinSource["setup_stdout"] = "setup_stdout";
    StdinSource["setup_stderr"] = "setup_stderr";
})(StdinSource = exports.StdinSource || (exports.StdinSource = {}));
var ExpectedOutputSource;
(function (ExpectedOutputSource) {
    ExpectedOutputSource["none"] = "none";
    ExpectedOutputSource["text"] = "text";
    ExpectedOutputSource["instructor_file"] = "instructor_file";
})(ExpectedOutputSource = exports.ExpectedOutputSource || (exports.ExpectedOutputSource = {}));
var ExpectedReturnCode;
(function (ExpectedReturnCode) {
    ExpectedReturnCode["none"] = "none";
    ExpectedReturnCode["zero"] = "zero";
    ExpectedReturnCode["nonzero"] = "nonzero";
})(ExpectedReturnCode = exports.ExpectedReturnCode || (exports.ExpectedReturnCode = {}));
var CustomScoringSource;
(function (CustomScoringSource) {
    CustomScoringSource["none"] = "none";
    CustomScoringSource["stdout"] = "stdout";
    CustomScoringSource["stderr"] = "stderr";
})(CustomScoringSource = exports.CustomScoringSource || (exports.CustomScoringSource = {}));
//# sourceMappingURL=ag_test_command.js.map